import { useReducer } from 'react';


type Action =
	| {
			type: 'CREATE';
			payload: { key: string; value: string[] };
	  }
	| {
		type: 'DELETE';
		payload: { key: string; value: string[] };
	}
	| {
		type: 'OFFSET';
		payload: number;
	}
	| {
		type: 'REMOVE_FROM_CREATE';
		payload: { key: string; value: string };
	}
	| {
		type: 'REMOVE_FROM_DELETE';
		payload: { key: string; value: string };
	}
	| {
		type: 'CLEAR';
	};

type State = {
	offset: number;
	create: Record<string, string[]>;
	delete: Record<string, string[]>;
};

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case 'CREATE': {
			const { key, value } = action.payload;
			return {
				...state,
				create: {
					...state.create,
					[key]: value,
				},
			};
		}
		case 'DELETE': {
			const { key, value } = action.payload;
			return {
				...state,
				delete: {
					...state.delete,
					[key]: value,
				},
			};
		}
		case 'OFFSET': {
			return {
				...state,
				offset: action.payload,
			};
		}
		case 'REMOVE_FROM_CREATE': {
			const { key, value } = action.payload;
			const create = { ...state.create }
			create[key].splice(create[key].indexOf(value), 1)
			if (create[key].length <= 0) {
				delete create[key]
			}
			return {
				...state,
				create: {
					...create
				},
			};
		}
		case 'REMOVE_FROM_DELETE': {
			const { key, value } = action.payload;
			const del = { ...state.delete }
			del[key].splice(del[key].indexOf(value), 1)
			if (del[key].length <= 0) {
				delete del[key]
			}
			return {
				...state,
				delete: {
					...del
				},
			};
		}
		case 'CLEAR': {
			return {
				...state,
				create: {},
				delete: {},
			};
		}
		default: {
			return state;
		}
	}
};

export function useEntities(offset: number) {
	const [state, dispatch] = useReducer(reducer, {
		offset,
		create: {},
		delete: {},
	});

	function addItem(key: string, value: string) {
		let val: string[] = [value]
		if (key in state.delete && state.delete[key].indexOf(value) !== -1) {
			dispatch({
				type: 'REMOVE_FROM_DELETE',
				payload: { key, value: value },
			});
		} else {
			if (key in state.create) {
				if (state.create[key].indexOf(value) === -1) {
					val = [value, ...state.create[key]]
				} else {
					val = [...state.create[key]]
				}
			}
			dispatch({
				type: 'CREATE',
				payload: { key, value: val },
			});
		}
	}

	function deleteItem(key: string, value: string) {
		let val: string[] = [value]
		if (key in state.create && state.create[key].indexOf(value) !== -1) {
			dispatch({
				type: 'REMOVE_FROM_CREATE',
				payload: { key, value: value },
			});
		} else {
			if (key in state.delete) {
				if (state.delete[key].indexOf(value) === -1) {
					val = [value, ...state.delete[key]]
				} else {
					val = [...state.delete[key]]
				}
			}
			dispatch({
				type: 'DELETE',
				payload: { key, value: val },
			});
		}
	}

	function clear() {
		dispatch({
			type: 'CLEAR',
		});
	}

	function setOffset(payload: number) {
		dispatch({
			type: 'OFFSET',
			payload
		});
	}

	const isDirty =
		Object.keys(state.create).length > 0 || Object.keys(state.delete).length > 0;

	return {
		actions: {
			addItem,
			deleteItem,
			clear,
			setOffset,
		},
		list: state.create,
		deleteList: state.delete,
		isDirty,
	};
}

export type EntitiesCRD = ReturnType<typeof useEntities>;
export type EntitiesCRDActions = EntitiesCRD['actions'];
export type EntitiesCRDList = EntitiesCRD['list'];
